export default __webpack_public_path__ + "static/presentacion-automoviles-virtual-hotwheelsGreenc-6930c0cc144e8965933121fe0cfa99b5.jpg";